export default __webpack_public_path__ + "static/media/map.57ea28d5.svg";